import type { ThirdPartyPlugin } from '../types';
import type { FullStory } from './types';
import { load } from './script';

declare global {
  interface Window {
    /**
     * @description Fullstory, contains API functions that are available as soon as the script has loaded.
     * @see [FS Types](https://github.com/fullstorydev/fullstory-browser-sdk/blob/main/src/index.d.ts)
     */
    FS?: FullStory;
  }
}

const ORG_ID = '68ZAT';

const fullStoryPlugin: ThirdPartyPlugin = ({ store }) => {
  const addUserInfo = () => {
    const setUser = () => {
      const { id, autoName: displayName, email } = store.state.auth.user;

      window?.FS?.identify(id, {
        displayName,
        email,
      });
    };

    if (store.state.auth.loggedIn) {
      setUser();
    } else {
      const unWatch = store.watch(
        state => state.auth.loggedIn,
        loggedIn => {
          if (loggedIn) {
            setUser();
            unWatch();
          }
        },
      );
    }
  };

  return {
    entry: window.FS,
    // TODO: must be implemented if we want to load fullstory immediatly
    load: () => {
      load(ORG_ID);
      addUserInfo();
      return Promise.resolve();
    },
  };
};

export default fullStoryPlugin;
